import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";

const getText = text => {
  return (
    <div
      style={{
        marginLeft: 10,
        marginTop: 5,
        marginBottom: 5,
        flex: 1,
        textAlign: "left"
      }}
    >
      {text}
    </div>
  );
};

export const Participant = ({ data, onEdit, onDelete }) => {
  return (
    <div
      className="participant"
      style={{
        marginTop: 10,
        width: 320,
        height: 180,
        borderRadius: 6,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginRight: 10,
          justifyContent: "flex-start",
          width: 320
        }}
      >
        <div style={{ flex: 1 }}>
          {getText((data.name && data.name !== "") ? data.name : "-")}
          {getText((data.gender === "male") ? "Laki-laki" : "Perempuan")}
          {getText((data.email && data.email !== "" ? data.email : "-"))}
          {getText((data.phone && data.phone !== "" ? data.phone : "-"))}
          {getText((data.student_id_number && data.student_id_number !== "" ? data.student_id_number : "-"))}
        </div>
        <Button
          onClick={onEdit}
          startIcon={<EditIcon />}
          style={{ alignSelf: "flex-start" }}
        >
          Edit
        </Button>
      </div>
      <Button
        color="secondary"
        onClick={onDelete}
        variant="text"
        startIcon={<DeleteIcon />}
        style={{ marginLeft: 5 }}
      >
        Hapus
      </Button>
    </div>
  );
};
